<template>
  <div class="task_page-new" id="task_answer">
    <!--<span class="task_answer_span"></span>-->
    <div class="task_main" ref="middle_page">
      <div class="taskPage">
        <div class="primarylists list-mobile">
          <div class="titles clear">
            <span class="title l">{{ $t("errorBook.errorBook") }}</span>
          </div>
        </div>
        <div class="div-btn-icon">
          <button class="btn-tast btn-next-1" @click="goto_lesson">
            <img src="../../../static/images/icon-back-1.png" alt="" />
            <span>{{ $t("common.returnButton") }}</span>
          </button>
          <template v-if="questions!=null&&currentQuestionInfo.questionNum==questions[0].questionNum">
            <button
              style="cursor: no-drop;"
              class="btn-tast"
            >
              <img src="../../../static/images/back-den.png" alt="" />
              <span style="color: black">{{ $t("errorBook.prve") }}</span>
            </button>
          </template>
          <template v-else>
            <button
              class="btn-tast"
              @click="changeQuestionF(parseInt(currentQuestionInfo.questionNum))"
            >
              <img src="../../../static/images/icon-back.png" alt="" />
              {{ $t("errorBook.prve") }}
            </button>
          </template>
          <template v-if="questions!=null&&currentQuestionInfo.questionNum==questions[questions.length - 1].questionNum">
            <button
              style="cursor: no-drop;"
              class="btn-tast xoay"
            >
              <img src="../../../static/images/back-den.png" alt="" />
              <span style="color: black">{{ $t("errorBook.next") }}</span>
            </button>
          </template>
          <template v-else>
            <button
              class="btn-tast xoay"
              @click="changeQuestionN(parseInt(currentQuestionInfo.questionNum))"
            >
              <img src="../../../static/images/icon-back.png" alt="" />
              {{ $t("errorBook.next") }}
            </button>
          </template>
          <button
            class="btn-tast"
            @click="delQuestion(parseInt(currentQuestionInfo.questionNum))"
          >
            <img src="../../../static/images/icon2.png" alt="" />
            {{ $t("errorBook.remove") }}
          </button>
        </div>
        <div class="taskPage_task taskPage_task_edit">
          <div class="taskContent_main">
            <div class="task-flex">
              <div class="task_content">
                <div
                  class="question-new"
                ></div>
                <p
                  class="p-top"
                  v-if="currentQuestionInfo.questionNum != undefined"
                  v-html="currentQuestionInfo.questionContent"
                ></p>
              </div>
              <audio
                v-if="
                  currentQuestionInfo.audioName != undefined &&
                  currentQuestionInfo.audioName != null &&
                  currentQuestionInfo.audioName != '' &&
                  'mp3' ==
                    currentQuestionInfo.audioName.substring(
                      currentQuestionInfo.audioName.lastIndexOf('.') + 1
                    )
                "
                controls="controls"
                :src="currentQuestionInfo.audioPath"
                controlsList="nodownload"
                oncontextmenu=" return false"
                class="audio"
              ></audio>
              <video
                v-if="
                  currentQuestionInfo.audioName != undefined &&
                  currentQuestionInfo.audioName != null &&
                  currentQuestionInfo.audioName != '' &&
                  'mp4' ==
                    currentQuestionInfo.audioName.substring(
                      currentQuestionInfo.audioName.lastIndexOf('.') + 1
                    )
                "
                :src="currentQuestionInfo.audioPath"
                controls="controls"
                controlsList="nodownload"
                class="video"
              ></video>
            </div>
            <div v-if="currentQuestionInfo.questionTypeId == '1'">
              <div class="testPage_answer_radio">
                <p v-if="currentQuestionInfo.optionA">
                  <input
                    v-model="radioValue"
                    id="radio_a"
                    type="radio"
                    name="radio"
                    value="A"
                    disabled="disabled"
                  />
                  <label for="radio_a">
                    <span class="left_span">A. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionA"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionB">
                  <input
                    v-model="radioValue"
                    id="radio_b"
                    type="radio"
                    name="radio"
                    value="B"
                    disabled="disabled"
                  />
                  <label for="radio_b">
                    <span class="left_span">B. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionB"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionC">
                  <input
                    v-model="radioValue"
                    id="radio_c"
                    type="radio"
                    name="radio"
                    value="C"
                    disabled="disabled"
                  />
                  <label for="radio_c">
                    <span class="left_span">C. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionC"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionD">
                  <input
                    v-model="radioValue"
                    id="radio_d"
                    type="radio"
                    name="radio"
                    value="D"
                    disabled="disabled"
                  />
                  <label for="radio_d">
                    <span class="left_span">D. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionD"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionE">
                  <input
                    v-model="radioValue"
                    id="radio_e"
                    type="radio"
                    name="radio"
                    value="E"
                    disabled="disabled"
                  />
                  <label for="radio_e">
                    <span class="left_span">E. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionE"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionF">
                  <input
                    v-model="radioValue"
                    id="radio_f"
                    type="radio"
                    name="radio"
                    value="F"
                    disabled="disabled"
                  />
                  <label for="radio_f">
                    <span class="left_span">F. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionF"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionG">
                  <input
                    v-model="radioValue"
                    id="radio_g"
                    type="radio"
                    name="radio"
                    value="G"
                    disabled="disabled"
                  />
                  <label for="radio_g">
                    <span class="left_span">G. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionG"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionH">
                  <input
                    v-model="radioValue"
                    id="radio_h"
                    type="radio"
                    name="radio"
                    value="H"
                    disabled="disabled"
                  />
                  <label for="radio_h">
                    <span class="left_span">H. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionH"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionI">
                  <input
                    v-model="radioValue"
                    id="radio_i"
                    type="radio"
                    name="radio"
                    value="I"
                    disabled="disabled"
                  />
                  <label for="radio_i">
                    <span class="left_span">I. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionI"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionJ">
                  <input
                    v-model="radioValue"
                    id="radio_j"
                    type="radio"
                    name="radio"
                    value="J"
                    disabled="disabled"
                  />
                  <label for="radio_j">
                    <span class="left_span">J. &nbsp;</span>
                    <span class="right_span" v-html="currentQuestionInfo.optionJ"></span>
                  </label>
                </p>
              </div>
            </div>
            <div
              class="tast-right"
              v-if="currentQuestionInfo.questionTypeId == '2'"
            >
              <div class="task_answer_radio task_answer_checkbox">
                <p v-if="currentQuestionInfo.optionA">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_a"
                    type="checkbox"
                    value="A"
                    disabled="disabled"
                  />
                  <label for="checkbox_a">
                    <span class="left_span">A.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionA"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionB">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_b"
                    type="checkbox"
                    value="B"
                    disabled="disabled"
                  />
                  <label for="checkbox_b">
                    <span class="left_span">B.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionB"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionC">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_c"
                    type="checkbox"
                    value="C"
                    disabled="disabled"
                  />
                  <label for="checkbox_c">
                    <span class="left_span">C.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionC"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionD">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_d"
                    type="checkbox"
                    value="D"
                    disabled="disabled"
                  />
                  <label for="checkbox_d">
                    <span class="left_span">D.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionD"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionE">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_e"
                    type="checkbox"
                    value="E"
                    disabled="disabled"
                  />
                  <label for="checkbox_e">
                    <span class="left_span">E.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionE"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionF">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_f"
                    type="checkbox"
                    value="F"
                    disabled="disabled"
                  />
                  <label for="checkbox_f">
                    <span class="left_span">F.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionF"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionG">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_g"
                    type="checkbox"
                    value="G"
                    disabled="disabled"
                  />
                  <label for="checkbox_g">
                    <span class="left_span">G.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionG"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionH">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_h"
                    type="checkbox"
                    value="H"
                    disabled="disabled"
                  />
                  <label for="checkbox_h">
                    <span class="left_span">H.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionH"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionI">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_i"
                    type="checkbox"
                    value="I"
                    disabled="disabled"
                  />
                  <label for="checkbox_i">
                    <span class="left_span">I.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionI"></span>
                  </label>
                </p>
                <p v-if="currentQuestionInfo.optionJ">
                  <input
                    class="ip-check"
                    v-model="checkedValue"
                    id="checkbox_j"
                    type="checkbox"
                    value="J"
                    disabled="disabled"
                  />
                  <label for="checkbox_j">
                    <span class="left_span">J.&nbsp;</span>
                    <span v-html="currentQuestionInfo.optionJ"></span>
                  </label>
                </p>
              </div>
            </div>
            <div
              class="tast-right tast-chat"
              v-if="
                currentQuestionInfo.questionTypeId == '3' ||
                currentQuestionInfo.questionTypeId == '4'
              "
            ></div>
            <table style="width: 100%; text-align: center;">
              <tr>
                <th>{{ $t("errorBook.answer") }}：</th>
                <th v-if="currentQuestionInfo.resolutionFlag=='1'">{{ $t("errorBook.rightAnswer") }}：</th>
              </tr>
              <tr>
                <td style="color: #fe5652; font-weight: 500; max-width: 160px;" v-html="currentQuestionInfo.commitAnswer"></td>
                <td style="color:forestgreen; font-weight: 500" v-if="currentQuestionInfo.resolutionFlag=='1'" v-html="currentQuestionInfo.questionAnswer"></td>
              </tr>
            </table>
            <br>
            <div class="exam_begins_rule-1">
              <p class="exam_begins_rule_title">
                {{ $t("errorBook.answerAnalysis") }}：
                <span
                  style="color: #fe5652"
                  v-html="currentQuestionInfo.questionAnalysis"
                ></span
                ><br />
                <span
                  style="color: #fe5652"
                  v-html="currentQuestionInfo.remarks"
                ></span>
              </p>
            </div>
          </div>
          <div class="taskContent_page">
            <el-pagination
              class="task_el_pagination"
              background
              layout="pager"
              :pageSize="1"
              :total="this.totalNum"
              hide-on-single-page="true"
              :current-page.sync="questionNum"
              @current-change="current_change"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <loading :showLoading="showLoadingFlg" />
  </div>
</template>

<script>
// import hljs from "highlight.js";
// import "highlight.js/styles/darkula.css";
// import "quill/dist/quill.snow.css";
import Vue from "vue";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
import loading from "@/components/loading/loading";
export default {
  name: "testPage",
  components: {
    loading,
  },
  data() {
    return {
      isCheckedStatus: false,
      showLoadingFlg: false,
      language: this.$lang(),
      button_remove_width: null,
      questionNumNew: 1,
      userId: null, //用户id
      courseId: null, //课程信息
      examId: null,
      courseName: null, //课程名称
      currentQuestionInfo: {},
      examTime: null, //考试用时
      questions: null, //试题列表
      type: null, //1.radio:单选,2.checkbox:多选,3.text:填空,4.tast_edit:编程界面
      textAnswer: null, //填空题答案
      totalNum: null, // 总题数
      questionNum: 1,
      checkedValue: [], //复选框选中
      radioValue: null, //单选选中
      spendTime: 0, //考试用时
      content: null,
      meanToleave: false,
      hasCommit: false,
      // editorOption: {
      //   modules: {
      //     syntax: {
      //       highlight: (text) => hljs.highlightAuto(text).value,
      //     },
      //     toolbar: [["code-block"]],
      //   },
      //   theme: "snow",
      //   // placeholder: window.vm.$i18n.t("js.placeholder"),
      // },
    };
  },
  mounted() {
    //获取设备屏幕的高度
    const h = document.body.clientHeight - 299;
    // this.$refs.middle_page.style.minHeight = h + "px";

    this.$autoLogin().then(
      () => {
        this.showLoadingFlg = true;
        this.userId = window.sessionStorage.getItem("id");
        //接收参数
        this.courseId = this.$route.query.courseId;
        this.courseName = this.$route.query.courseName;
        this.examId = this.$route.query.examId;
        //获取错题内容
        this.$api
          .post("/studyCourseQuestion/getScheduleWrongBook", {
            languageType: this.$lang(),
            courseId: this.courseId,
            examId: this.examId
          })
          .then((response) => {
            this.questions = null;
            this.questions = response.data;
            // this.questions.forEach(function (obj) {
            //   if (obj.questionTypeId == '2') {
            //     obj.commitAnswer = obj.commitAnswer == null || obj.commitAnswer == '' ? [] : obj.commitAnswer.toString().split(",");
            //   }
            // })
            this.currentQuestionInfo = this.questions[0];

            //答案赋值
            if (this.currentQuestionInfo.questionTypeId == "1") {
              this.radioValue = this.currentQuestionInfo.commitAnswer;
            } else if (this.currentQuestionInfo.questionTypeId == "2") {
              this.currentQuestionInfo.commitAnswer == null ||
              this.currentQuestionInfo.commitAnswer == ""
                ? (this.checkedValue = "")
                : (this.checkedValue = this.currentQuestionInfo.commitAnswer
                    .toString()
                    .split(","));
            } else {
              this.textAnswer = this.currentQuestionInfo.commitAnswer;
            }
            this.totalNum = response.data.length;
            this.examTime = response.data.examTime * 60;
            this.showLoadingFlg = false;
          });
      },
      () => {
        //未登录跳回首页
        this.$router.push({
          path: "/home",
        });
      }
    );
    if (this._isMobile()) {
      this.isCheckedStatus = true;
    } else {
      this.isCheckedStatus = false;
    }
  },
  methods: {
    errorExport: function () {
      this.$api
        .post("/studyCourseQuestion/errorExport", {
          courseId: this.courseId,
          languageType: this.$lang(),
        })
        .then((response) => {
          window.open(response.data);
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    goto_lesson: function () {
      let outlineInfo = {
        courseId: this.$route.query.courseId,
        courseName: this.$route.query.courseName,
      };
      this.$router.push({
        path: "/home/schedule/scheduleWrongbookBegin",
        query: {
          courseId: this.$route.query.courseId,
          courseName: this.$route.query.courseName,
        },
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    current_change: function (val) {
      this.changeQuestion(this.questions[val - 1].questionNum);
    },
    saveAnswer: function () {
      let saveNum = parseInt(this.currentQuestionInfo.questionNum) - 1;
      if (this.questions[saveNum].questionTypeId == "1") {
        this.questions[saveNum].commitAnswer =
          this.radioValue == null ? "" : this.radioValue;
      } else if (this.questions[saveNum].questionTypeId == "2") {
        this.checkedValue.sort();
        this.questions[saveNum].commitAnswer =
          this.checkedValue.length == 0 ? "" : this.checkedValue;
      } else {
        this.questions[saveNum].commitAnswer =
          this.textAnswer == null ? "" : this.textAnswer;
      }
    },
    changeQuestion: function (questionNum) {
      let i = 0;
      for (let key in this.questions) {
        i = i + 1;
        if (questionNum == this.questions[key].questionNum) {
          this.questionNum = i;
        }
      }
      //保存答案
      // this.saveAnswer();
      //清除页面答案
      this.textAnswer = null;
      this.radioValue = null;
      this.checkedValue = [];
      //切换问题
      this.currentQuestionInfo = this.questions[this.questionNum - 1];
      //答案赋值
      if (this.currentQuestionInfo.questionTypeId == "1") {
        this.radioValue = this.currentQuestionInfo.commitAnswer;
      } else if (this.currentQuestionInfo.questionTypeId == "2") {
        this.currentQuestionInfo.commitAnswer == null ||
        this.currentQuestionInfo.commitAnswer == ""
          ? (this.checkedValue = "")
          : (this.checkedValue = this.currentQuestionInfo.commitAnswer
              .toString()
              .split(","));
      } else {
        this.textAnswer = this.currentQuestionInfo.commitAnswer;
      }
      //this.questionNum = questionNum;
    },
    changeQuestionF: function (questionNum) {
      let i = 0;
      for (let key in this.questions) {
        i = i + 1;
        if (questionNum == this.questions[key].questionNum) {
          this.questionNum = i - 1;
        }
      }
      //保存答案
      // this.saveAnswer();
      //清除页面答案
      this.textAnswer = null;
      this.radioValue = null;
      this.checkedValue = [];
      //切换问题
      this.currentQuestionInfo = this.questions[this.questionNum - 1];
      //答案赋值
      if (this.currentQuestionInfo.questionTypeId == "1") {
        this.radioValue = this.currentQuestionInfo.commitAnswer;
      } else if (this.currentQuestionInfo.questionTypeId == "2") {
        this.currentQuestionInfo.commitAnswer == null ||
        this.currentQuestionInfo.commitAnswer == ""
          ? (this.checkedValue = "")
          : (this.checkedValue = this.currentQuestionInfo.commitAnswer
              .toString()
              .split(","));
      } else {
        this.textAnswer = this.currentQuestionInfo.commitAnswer;
      }
    },
    changeQuestionN: function (questionNum) {
      let i = 0;
      for (let key in this.questions) {
        i = i + 1;
        if (questionNum == this.questions[key].questionNum) {
          this.questionNum = i + 1;
        }
      }
      //保存答案
      // this.saveAnswer();
      //清除页面答案
      this.textAnswer = null;
      this.radioValue = null;
      this.checkedValue = [];
      //切换问题
      this.currentQuestionInfo = this.questions[this.questionNum - 1];
      //答案赋值
      if (this.currentQuestionInfo.questionTypeId == "1") {
        this.radioValue = this.currentQuestionInfo.commitAnswer;
      } else if (this.currentQuestionInfo.questionTypeId == "2") {
        this.currentQuestionInfo.commitAnswer == null ||
        this.currentQuestionInfo.commitAnswer == ""
          ? (this.checkedValue = "")
          : (this.checkedValue = this.currentQuestionInfo.commitAnswer
              .toString()
              .split(","));
      } else {
        this.textAnswer = this.currentQuestionInfo.commitAnswer;
      }
    },
    delQuestion: function (questionNum) {
      let i = 0;
      for (let key in this.questions) {
        i = i + 1;
        if (questionNum == this.questions[key].questionNum) {
          this.questionNumNew = i;
        }
      }
      this.$confirm(
        window.vm.$i18n.t("errorBook.confirmMessage"),
        window.vm.$i18n.t("js.hint"),
        {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
          cancelButtonText: window.vm.$i18n.t("js.cancel"),
          cancelButtonClass: "btn-custom-cancel",
        }
      )
        .then(() => {
          this.showLoadingFlg = true;
          this.$api
            .post("/studyCourseQuestion/delScheduleWrongBook", {
              courseId: this.courseId,
              questionNum: questionNum,
              examId: this.examId
            })
            .then((response) => {
              let that = this;
              if (response.data > 0) {
                this.$api
                  .post("/studyCourseQuestion/getScheduleWrongBook", {
                    languageType: that.$lang(),
                    courseId: that.courseId,
                    examId: that.examId
                  })
                  .then((response) => {
                    that.questions = response.data;
                    if (that.questions != null) {
                      if (that.questions.length >= that.questionNumNew) {
                        // this.questions.splice(this.questionNumNew - 1, 1);
                        that.currentQuestionInfo =
                          that.questions[that.questionNumNew - 1];
                        that.totalNum = that.questions.length;
                        that.questionNum = that.questionNumNew;
                        that.questionNumNew = that.questionNumNew - 1;
                        //保存答案
                        // this.saveAnswer();
                        //清除页面答案
                        that.textAnswer = null;
                        that.radioValue = null;
                        that.checkedValue = [];
                        //切换问题
                        that.currentQuestionInfo =
                          that.questions[that.questionNum - 1];
                        this.showLoadingFlg = false;
                      } else {
                        if (that.questions.length == 0) {
                          that.goto_lesson();
                        }
                        // 最后一题
                        // this.questions.splice(this.questionNumNew - 1, 1);
                        that.currentQuestionInfo =
                          that.questions[that.questionNumNew - 2];
                        that.totalNum = that.questions.length;
                        that.questionNum = that.questionNumNew - 1;
                        that.questionNumNew = that.questionNumNew - 2;
                        //保存答案
                        // this.saveAnswer();
                        //清除页面答案
                        that.textAnswer = null;
                        that.radioValue = null;
                        that.checkedValue = [];
                        //切换问题
                        that.currentQuestionInfo =
                          that.questions[that.questionNum - 1];
                        this.showLoadingFlg = false;
                      }
                    } else {
                      let outlineInfo = {
                        courseId: this.$route.query.courseId,
                        courseName: this.$route.query.courseName,
                      };
                      this.$router.push({
                        path: "schedule/schedule_curriculum",
                        query: {
                          outlineInfo: JSON.stringify(outlineInfo),
                        },
                      });
                    }
                  });
              }
            });
        })
        .catch(() => {
          this.showLoadingFlg = false;
        });
    },
    commit() {
      this.meanToleave = true;
      //保存答案
      this.saveAnswer();
      let answers = [];
      this.questions.forEach(function (obj) {
        if (obj.commitAnswer == null) {
          obj.commitAnswer = "";
        }

        if (obj.questionTypeId == 2 && obj.commitAnswer.length != 0) {
          let answer = obj.commitAnswer[0];
          for (let i = 1; i < obj.commitAnswer.length; i++) {
            answer += "," + obj.commitAnswer[i];
          }
          obj.commitAnswer = answer;
        }
        let objective = {
          questionNum: obj.questionNum,
          commitAnswer: obj.commitAnswer,
          questionTypeId: obj.questionTypeId,
          questionAnswer: obj.questionAnswer,
          questionId: obj.questionId,
          questionScore: obj.questionScore,
        };
        answers.push(objective);
      });

      let param = {
        courseId: this.courseId,
        spendTime: this.spendTime,
        answers: answers,
        isCommit: 1,
      };
      this.$api.post("/studyCourseQuestion/commitScheduleExam", param).then(() => {
        /*this.$el_alert_type('提交成功', 'success');*/
        let outlineInfo = {
          courseId: this.courseId,
          courseName: this.courseName,
        };
        this.$router.push({
          path: "schedule/schedule_curriculum",
          query: {
            outlineInfo: JSON.stringify(outlineInfo),
          },
        });
      });
    },
    //离开考试页面提交考试答案
    leavePageCommit: function () {
      //保存答案
      this.saveAnswer();
      let answers = [];
      this.questions.forEach(function (obj) {
        if (obj.commitAnswer == null) {
          obj.commitAnswer = "";
        }

        if (obj.questionTypeId == 2 && obj.commitAnswer.length != 0) {
          let answer = obj.commitAnswer[0];
          for (let i = 1; i < obj.commitAnswer.length; i++) {
            answer += "," + obj.commitAnswer[i];
          }
          obj.commitAnswer = answer;
        }
        let objective = {
          questionNum: obj.questionNum,
          commitAnswer: obj.commitAnswer,
          questionTypeId: obj.questionTypeId,
          questionAnswer: obj.questionAnswer,
          questionId: obj.questionId,
          questionScore: obj.questionScore,
        };
        answers.push(objective);
      });

      let param = {
        courseId: this.courseId,
        spendTime: this.spendTime,
        answers: answers,
        isCommit: 0,
      };

      let xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        this.$rootUrl + "/studyCourseQuestion/commitScheduleExam",
        false
      );
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify(param));
    },
    s_to_ms: function (s) {
      let m;
      m = Math.floor(s / 60);
      s = s % 60;
      return m == 0 ? s + "s" : m + "min" + s + "s";
    },
    time_format: function (time) {
      let h;
      let m;
      let s;
      h = Math.floor(time / 3600);
      m = Math.floor(time / 60) - 60 * h;
      s = time % 60;
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return h + ":" + m + ":" + s;
    },
  },
};
</script>

<style scoped="scoped">
.task_page {
  width: 100%;
  min-width: 480px;
  background-color: rgb(100, 101, 112);
  background: url(../../../static/images/bg/personset_bg.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
}

.task_main {
  background-color: rgba(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
}

.taskPage {
  /*min-width: 1200px;*/
  width: 80%;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 50px;
  position: relative;
}

.task_answer_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.taskPage_top {
  margin-top: 60px;
}

.taskPage_top p {
  width: calc(60% + 80px);
  /* height: 30px; */
  line-height: 30px;
  margin: 0 auto;
  color: #e8e6e6;
  font-size: 30px;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
}

.taskPage_top p:last-child {
  font-size: 20px;
}

.taskPage_task_b {
  min-width: 600px;
  width: 60%;
  margin: 0 auto;
  padding-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0px 0px 20px 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  min-height: 50px;
  position: relative;
}

.taskPage_task {
  min-width: 600px;
  width: 60%;
  margin: 0 auto;
  margin-top: 40px;
  /*padding: 0 20px;*/
  padding-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px 20px 0px 0px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
}

.taskPage_task .task_top {
  height: 40px;
  line-height: 40px;
}

.task_btn {
  height: 25px;
  line-height: 25px;
  width: 60px;
  margin: 10px 0 0 20px;
  background-color: unset;
  font-size: 12px;
  color: rgb(232, 230, 230);
  font-weight: 200;
  border: 1px #fff solid;
  transition: 0.5s ease;
  border-radius: 12.5px;
}

.task_btn:hover {
  background-color: #fff;
  color: #000;
  transition: 0.5s ease;
}

.previous_task {
  position: relative;
  float: left;
  cursor: pointer;
}

.next_task {
  position: relative;
  float: right;
  margin-top: -40px;
  cursor: pointer;
}

.taskContent_page {
  width: 80%;
  height: 40px;
  position: relative;
  margin: 0 auto;
}

.taskContent_main {
  margin-top: 20px;
  padding: 0 100px;
  font-size: 14px;
  color: #1f1717;
  text-align: left;
  /*height: 270px;*/
  word-wrap: break-word;
  /* word-break: break-all; */
}

.taskContent_main .task_content {
  line-height: 20px;
  font-size: 14px;
  color: #1f1717;
  /* text-align: left; */
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

.taskContent_main .task_content p {
  width: 100%;
}

.taskContent_main .answer_note {
  margin-bottom: 10px;
  color: #ff5252;
  font-size: 12px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.task_answer_radio {
  /*min-width: 450px;*/
  /*width: cacl(60% - 50px);*/
  margin-top: 20px;
  /*margin-left: 20px;*/
}

.task_answer_radio p {
  width: calc(100% - 40px);
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  /* text-align: left; */
  /*margin-left: 20px;*/
  margin-top: 15px;
  /* display: inline-flex; */
  display: -webkit-box;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

.task_answer_radio p label {
  display: -webkit-box;
}

.task_answer_radio p span {
  cursor: pointer;
}

.task_answer_radio input {
  height: 13px;
  margin-right: 10px;
  margin-top: 5px;
}

.task_answer_text {
  margin-top: 20px;
  width: calc(100% - 40px);
  padding: 2px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #585858;
  border-radius: 20px;
}
.task_answer_text:focus {
  border: 1px #ff5252 solid !important;
}

.task_answer_text textarea {
  margin-top: 2px;
  margin-right: 1px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 160px;
  line-height: 20px;
  background-color: #fff;
  border-radius: 20px;
  /* background:url("../../../static/images/manual_zh_10.png") no-repeat; */
  font-size: 14px;
  color: #0f0f0f;
  text-align: left;
  border: 0;
  outline: none;
  padding-left: 8px;
  padding-right: 8px;
  /* resize: none; */
}
.task_answer_text textarea:focus {
  border: 0 !important;
  background: #585858;
  color: #e8e6e6;
}

.task_answer_text textarea::-webkit-input-placeholder {
  color: #e8e6e6;
}

.task_answer_text textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #e8e6e6;
}

.task_answer_text textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #e8e6e6;
}

.task_answer_text textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #e8e6e6;
}
.submitButton_d {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 40%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.submitButton_c {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 60%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton_c:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.submitButton {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.prev_btn {
  left: calc(30% - 100px);
  bottom: 30px;
}
.next_btn {
  left: calc(70% + 100px);
  bottom: 30px;
}
.task_post .el-dialog {
  background-color: #585858;
}
.taskPage_task_edit {
  /*width: 100%;*/
  min-height: 500px;
  position: relative;
}

.taskPage_task_edit .taskContent_page {
  /*margin-left: 272px;*/
}
.commit_dialog {
  background-color: #585858;
}
.right_span {
  float: right;
}

@media screen and (max-width: 1024px) {
  .taskPage {
    width: 94%;
    /*min-width: 500px;*/
    padding: 3%;
  }
  .taskPage_task_edit {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskPage_task_b {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskContent_main {
    padding: 0 50px;
  }
}

.primarylists .titles .title {
  text-transform: none!important;
}
</style>
<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/schedule/scheduleWrongbook.vue